import { jsxs as d, jsx as r } from "react/jsx-runtime";
import { E as g, S as p } from "./icons.types-0722eef5.js";
function m({ title: i, titleId: l, size: o, width: a, height: c, extended: t = !1, ...n }) {
  const s = t ? g : p, e = o ? s[o] : a || s[t ? "s" : "l"], h = o ? s[o] : c || s[t ? "s" : "l"];
  return /* @__PURE__ */ d(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 23 16",
      width: e,
      height: h,
      "aria-labelledby": l,
      ...n,
      children: [
        i ? /* @__PURE__ */ r("title", { id: l, children: i }) : null,
        /* @__PURE__ */ r(
          "path",
          {
            fill: "currentColor",
            d: "M11.177 7.181H9.85a1.653 1.653 0 0 0-.21-.579 1.557 1.557 0 0 0-.898-.7 2.023 2.023 0 0 0-.621-.092c-.396 0-.746.1-1.051.299-.306.196-.545.485-.718.866-.172.379-.259.842-.259 1.389 0 .556.087 1.025.26 1.406.175.379.414.665.717.86.305.191.654.287 1.047.287.218 0 .422-.028.611-.085.192-.06.363-.146.515-.26a1.582 1.582 0 0 0 .607-.987l1.328.007a2.86 2.86 0 0 1-.323.973c-.163.303-.377.57-.643.803-.265.23-.575.41-.93.54-.355.128-.75.191-1.183.191-.639 0-1.21-.148-1.711-.444A3.098 3.098 0 0 1 5.2 10.374c-.289-.56-.433-1.23-.433-2.01 0-.784.145-1.454.436-2.01a3.121 3.121 0 0 1 1.19-1.282 3.292 3.292 0 0 1 1.704-.444c.405 0 .782.057 1.13.17.348.114.658.28.93.501.272.218.496.485.671.803.178.314.294.674.348 1.08Zm7.432 0h-1.328a1.653 1.653 0 0 0-.21-.579 1.557 1.557 0 0 0-.898-.7 2.023 2.023 0 0 0-.622-.092c-.395 0-.745.1-1.05.299-.306.196-.545.485-.718.866-.173.379-.26.842-.26 1.389 0 .556.087 1.025.26 1.406.175.379.414.665.717.86.306.191.655.287 1.048.287.218 0 .421-.028.61-.085a1.67 1.67 0 0 0 .516-.26 1.584 1.584 0 0 0 .607-.987l1.328.007a2.86 2.86 0 0 1-.323.973c-.164.303-.378.57-.643.803-.265.23-.575.41-.93.54-.355.128-.75.191-1.183.191-.64 0-1.21-.148-1.711-.444a3.097 3.097 0 0 1-1.187-1.281c-.288-.56-.433-1.23-.433-2.01 0-.784.146-1.454.437-2.01a3.121 3.121 0 0 1 1.19-1.282 3.292 3.292 0 0 1 1.704-.444c.405 0 .781.057 1.13.17.347.114.657.28.93.501.272.218.496.485.671.803.178.314.294.674.348 1.08Z"
          }
        ),
        /* @__PURE__ */ r(
          "rect",
          {
            width: 20.5,
            height: 14.5,
            x: 1.417,
            y: 0.75,
            stroke: "currentColor",
            strokeWidth: 1.5,
            rx: 1.25
          }
        )
      ]
    }
  );
}
export {
  m as ClosedCaptions
};
